import ApiService from './api'
import store from '@/member/stores/store'
import { subMinutes } from 'date-fns'

export default {
  async post(url, params = {}, isCheckAuth = true, isRefresh = false) {
    try {
      if (store.state.commonStore.isCallingApi[url]) return
      store.commit('commonStore/SET_IS_CALLING_API', { url, status: true })

      let result
      try {
        result = await ApiService.post(url, params)
      } catch (e) {
        // Unauthenticated 401が返された場合は /login へリダイレクト
        store.commit('commonStore/SET_IS_CALLING_API', { url, status: false })

        if (e.response.status === 401) {
          return (location.href = '/login')
        }

        return {
          success: false,
          errorCode: e.response ? e.response.status : 500,
          data: e.response ? e.response.data : 'error',
          error: e,
        }
      }

      store.commit('commonStore/SET_IS_CALLING_API', { url, status: false })

      // refresh token after get refresh token
      if (isRefresh) {
        await ApiService.refresh(result.data.data.auth_token)
      }

      return {
        success: result.data.success,
        message: result.data.message,
        data: result.data.data,
      }
    } catch (e) {
      store.commit('commonStore/SET_IS_CALLING_API', { url, status: false })
      return {
        success: false,
        errorCode: e.response ? e.response.status : 500,
        data: e.response ? e.response.data : 'error',
        error: e,
      }
    }
  },
  async get(url, params = {}, isCheckAuth = true, isRefresh = false) {
    try {
      if (store.state.commonStore.isCallingApi[url]) return
      store.commit('commonStore/SET_IS_CALLING_API', { url, status: true })

      let result
      try {
        result = await ApiService.get(url, params)
      } catch (e) {
        // Unauthenticated 401が返された場合は /login へリダイレクト
        store.commit('commonStore/SET_IS_CALLING_API', { url, status: false })

        if (e.response.status === 401) {
          return (location.href = '/login')
        }
      }

      store.commit('commonStore/SET_IS_CALLING_API', { url, status: false })

      // refresh token after get refresh token
      if (isRefresh) {
        await ApiService.refresh(result.data.data.auth_token)
      }

      return {
        success: result.data.success,
        message: result.data.message,
        data: result.data.data,
      }
    } catch (e) {
      store.commit('commonStore/SET_IS_CALLING_API', { url, status: false })
      return {
        success: false,
        errorCode: e.response ? e.response.status : 500,
        data: e.response ? e.response.data : 'error',
        error: e,
      }
    }
  },
  async downloadFromS3(url, params = {}, responseType = 'arraybuffer') {
    try {
      store.commit('commonStore/SET_IS_CALLING_API', true)

      let result = await ApiService.get(url, params, { responseType: responseType })
      store.commit('commonStore/SET_IS_CALLING_API', false)
      return {
        headers: result.headers,
        status: result.status,
        data: result.data,
      }
    } catch (e) {
      return {
        success: false,
        errorCode: e.response ? e.response.status : 500,
        data: e.response ? e.response.data : 'error',
        error: e,
      }
    }
  },
  async downloadCsv(url, params = {}, responseType = 'blob') {
    try {
      store.commit('commonStore/SET_IS_CALLING_API', true)

      let result = await ApiService.get(url, params, { responseType: responseType })
      store.commit('commonStore/SET_IS_CALLING_API', false)
      return {
        headers: result.headers,
        status: result.status,
        data: result.data,
      }
    } catch (e) {
      return {
        success: false,
        errorCode: e.response ? e.response.status : 500,
        data: e.response ? e.response.data : 'error',
        error: e,
      }
    }
  },
  async downloadApplicationForm(url, params = {}, responseType = 'blob') {
    try {
      store.commit('commonStore/SET_IS_CALLING_API', true)

      if (typeof url !== 'string' || url.length === 0) throw new Error('Invalid URL')
      let result = await ApiService.get(url, params, { responseType: responseType })
      return {
        headers: result.headers,
        status: result.status,
        data: result.data,
      }
    } catch (e) {
      return {
        success: false,
        errorCode: e.response ? e.response.status : 500,
        data: e.response ? e.response.data : 'error',
        error: e,
      }
    } finally {
      store.commit('commonStore/SET_IS_CALLING_API', false)
    }
  },
  async refresh(token = '') {
    if (!token) return
    await ApiService.refresh(token)
  },
}
